import { Fragment } from 'react';
import {
    TextField,
    Button,
    IconButton,
    InputAdornment,
    CircularProgress,
    Divider
} from '@mui/material';
import { HighlightOff } from '@mui/icons-material';
import AlertDialog from '../../../../../components/Dialog/AlertDialog';
import ExcelUploader from '../../../../../components/file-input/ExcelUploader';
import InvitationTemplate from '../../../../../assets/documents/InvitationTemplate.xlsx'
import { H6, Body3 } from '../../../../../themes/typography';
import '../../../../../styles/components/Team.css';

function AddInvitations({
    formik,
    addInvitation = () => { },
    deleteInvitation = () => { },
    cancelAllForm = () => { },
    loading,
    openInvitationForm,
    maxInviteLimit,
    openExcelUploadModal,
    setOpenExcelUploadModal,
    fileInputRef,
    excelFileError,
    file,
    removeUploadedFile,
    handleFileInput,
    fileUploadStatus,
    submitExcelDataToForm = () => { },
    progress
}) {

    return (
        <Fragment>
            <div className="add-event-check-in-staff-container">
                <form className="add-event-staff-form" onSubmit={formik.handleSubmit} noValidate>
                    <div className="add-event-staff-form-actions">
                        <Button
                            variant="text"
                            sx={{ cursor: 'default' }}
                        >
                            {maxInviteLimit?.counter} / {maxInviteLimit?.limit}
                        </Button>
                        <Button
                            onClick={() => {
                                removeUploadedFile();
                                setOpenExcelUploadModal(true);
                            }}
                            disabled={maxInviteLimit?.counter >= maxInviteLimit?.limit}
                        >
                            Upload File
                        </Button>
                        <Button
                            variant="main"
                            onClick={addInvitation}
                            disabled={maxInviteLimit?.counter >= maxInviteLimit?.limit}
                        >
                            Add Invitation
                        </Button>
                    </div>
                    <div className="add-event-staff-form-content-container">
                        {openInvitationForm && fileUploadStatus !== 'loading' && (
                            <div className="add-event-staff-form-content">
                                <div className='check-in-staff-inputs-list'>
                                    {(formik.values.invitations || [])?.map((member, index) => (
                                        <Fragment key={index}>
                                            <div className="check-in-staff-inputs">
                                                <TextField
                                                    fullWidth
                                                    id={`invitations[${index}].name`}
                                                    name={`invitations[${index}].name`}
                                                    label="Name"
                                                    type="text"
                                                    value={member.name}
                                                    onChange={formik.handleChange}
                                                    error={
                                                        formik.touched.invitations &&
                                                        Boolean(
                                                            formik.errors.invitations?.[index]?.name
                                                        )
                                                    }
                                                    helperText={
                                                        formik.touched.invitations &&
                                                        formik.errors.invitations?.[index]?.name
                                                    }
                                                />
                                                <TextField
                                                    fullWidth
                                                    id={`invitations[${index}].email`}
                                                    name={`invitations[${index}].email`}
                                                    label="Email"
                                                    type="email"
                                                    value={member.email}
                                                    onChange={formik.handleChange}
                                                    error={
                                                        formik.touched.invitations &&
                                                        Boolean(
                                                            formik.errors.invitations?.[index]?.email
                                                        )
                                                    }
                                                    helperText={
                                                        formik.touched.invitations &&
                                                        formik.errors.invitations?.[index]?.email
                                                    }
                                                />
                                                <TextField
                                                    fullWidth
                                                    id={`invitations[${index}].phone`}
                                                    name={`invitations[${index}].phone`}
                                                    label="Phone"
                                                    value={member.phone}
                                                    onChange={formik.handleChange}
                                                    error={
                                                        formik.touched.invitations &&
                                                        Boolean(
                                                            formik.errors.invitations?.[index]?.phone
                                                        )
                                                    }
                                                    helperText={
                                                        formik.touched.invitations &&
                                                        formik.errors.invitations?.[index]?.phone
                                                    }
                                                    slotProps={{
                                                        input: {
                                                            startAdornment: (
                                                                <InputAdornment position="start">
                                                                    +91
                                                                </InputAdornment>
                                                            ),
                                                            inputMode: 'numeric',
                                                            pattern: '[0-9]*',
                                                            onInput: (e) => {
                                                                e.target.value = e.target.value.replace(
                                                                    /\D/g,
                                                                    ''
                                                                );
                                                                if (e.target.value.length > 10) {
                                                                    e.target.value =
                                                                        e.target.value.slice(0, 10);
                                                                }
                                                            }
                                                        }
                                                    }}
                                                />
                                                <IconButton
                                                    color="secondary"
                                                    sx={{ marginTop: '0.5rem' }}
                                                    onClick={() => deleteInvitation(index)}
                                                >
                                                    <HighlightOff sx={{ fontSize: '1.75rem' }} />
                                                </IconButton>
                                            </div>
                                            {index !== formik.values.invitations.length - 1 && (
                                                <Divider
                                                    sx={{
                                                        borderColor: 'var(--divider-color)',
                                                        alignSelf: 'stretch'
                                                    }}
                                                />
                                            )}
                                        </Fragment>
                                    ))}
                                </div>
                                <div className="send-staff-form-actions">
                                    <Button variant="text" onClick={cancelAllForm}>
                                        Cancel
                                    </Button>
                                    <Button
                                        type="submit"
                                        variant="main"
                                        disabled={loading}
                                    >
                                        Send Invitation {loading && (
                                            <CircularProgress
                                                size={20}
                                                sx={{
                                                    marginLeft: '0.75rem',
                                                    color: 'var(--primary-color)'
                                                }}
                                            />
                                        )}
                                    </Button>
                                </div>
                            </div>
                        )}
                    </div>
                </form>
            </div>

            <AlertDialog
                open={openExcelUploadModal}
                onCancel={() => {
                    setOpenExcelUploadModal(false)
                    removeUploadedFile()
                }}
                onConfirm={submitExcelDataToForm}
                primaryBtnName="Submit"
                secondaryBtnName="Cancel"
                dialogTitle="Upload Invitations File"
                disabled={excelFileError || !file}
            >
                <div className='upload-excel-invitation-container'>
                    <ExcelUploader
                        fileInputRef={fileInputRef}
                        error={excelFileError}
                        file={file}
                        removeUploadedFile={removeUploadedFile}
                        handleFileInput={handleFileInput}
                        status={fileUploadStatus}
                        fullWidth={true}
                        progress={progress}
                    />

                    <div className='upload-excel-invitation-instructions-container'>
                        <H6 fontWeight={400}>
                            Instructions to upload the excel file:
                        </H6>

                        <div className='upload-excel-invitation-instructions'>
                            <ol>
                                <Body3 fontWeight={350}>
                                    <li>
                                        Download the sample invitation file template from <span className='invitation-file-link'><a href={InvitationTemplate} download>here</a></span>.
                                    </li>
                                </Body3>

                                <Body3 fontWeight={350}>
                                    <li>
                                        Only Name, Email and Phone columns are mandatory.
                                    </li>
                                </Body3>

                                <Body3 fontWeight={350}>
                                    <li>
                                        Duplicate entries are not allowed.
                                    </li>
                                </Body3>

                                <Body3 fontWeight={350}>
                                    <li>
                                        Maximum {maxInviteLimit?.limit} invitations are allowed.
                                    </li>
                                </Body3>
                            </ol>
                        </div>
                    </div>
                </div>
            </AlertDialog>
        </Fragment>
    );
}

export default AddInvitations;